import { myPagesBaseApi } from '../../_baseApi/myPages.base.api';
import { mapLoanData } from './loan.mapper';
import { LoanGetRequestDto } from '~/store/apis/dtos/invoices/invoices.dto';
import { generateParams } from '~/store/apis/utils/generateParams';
import {
  LoanOfferByIdGetResponseDto,
  LoanOfferGetRequestDto,
} from '~/store/apis/dtos/loanOffer/loanOffer.dto';
import { LoanGetResponseDto } from '~/store/apis/dtos/loan/loans.dto';
import { Loan } from '~/models/loan/loan';

export const loanApi = myPagesBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoan: builder.query<Loan | undefined, LoanGetRequestDto>({
      query: ({ ...rest }) => `/loan?${generateParams(rest)}`,
      providesTags: (_, _meta, arg) => [{ type: 'Loan', id: arg.companyId }],
      transformResponse: (response: LoanGetResponseDto, _meta, args) =>
        mapLoanData(response, args),
    }),

    getLoanOfferById: builder.query<
      LoanOfferByIdGetResponseDto,
      LoanOfferGetRequestDto
    >({
      query: ({ clientId, ...rest }) =>
        `/loans/offer/${clientId}?${generateParams(rest)}`,
      providesTags: (_, _meta, arg) => [
        { type: 'LoanOffer', id: arg.clientId },
      ],
    }),
  }),
});
export const { useGetLoanOfferByIdQuery, useGetLoanQuery } = loanApi;
